/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".panel-header[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-content:space-between;align-items:center}.use-existing-map[_ngcontent-%COMP%]{margin:0}"];
export { styles as styles };
